import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

const audioFile = require('../assets/audio/SC_FirstLight.mp3');

const AudioPlayer = () => {
    const [isMuted, setIsMuted] = useState(true); // Iniciamos silenciado por UX
    const [srcLoaded, setSrcLoaded] = useState(false);
    const audioRef = useRef(null);
    const navigate = useNavigate();
    const [clickCount, setClickCount] = useState(0);
    const [lastClickTime, setLastClickTime] = useState(0);

    const toggleMute = () => {
        if (audioRef.current) {
            const currentTime = Date.now();
            
            // Si han pasado más de 2 segundos, reiniciar el contador
            if (currentTime - lastClickTime > 2000) {
                setClickCount(1);
            } else {
                // Si estamos dentro del tiempo, incrementar contador
                if (clickCount === 10) {
                    navigate('/secret-shop');
                    setClickCount(0);
                } else {
                    setClickCount(prev => prev + 1);
                }
            }
            
            setLastClickTime(currentTime);

            // Cargar el src solo al hacer play
            if (!srcLoaded) {
                audioRef.current.src = audioFile;
                setSrcLoaded(true);
            }

            // Actualizar el estado del audio
            if (isMuted) {
                audioRef.current.play();
            }
            audioRef.current.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };

    return (
        <div className="audio-player">
            <audio ref={audioRef} preload="none" />
            <button 
                className="mute-button"
                onClick={toggleMute}
                aria-label={isMuted ? "Activar sonido" : "Silenciar"}
            >
                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </button>
        </div>
    );
};

export default AudioPlayer; 